import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { FirestoreService } from 'src/app/services/firebase/firestore.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import {Sort, MatSort} from '@angular/material/sort';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
declare var $: any;


@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css'],
})
export class TrackingComponent implements OnInit {
  // Accessing HTML Element
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  forma: FormGroup;

  dateto: any;
  dateend: any;

  user: any;

  today = new Date();

  urlImg: any = '../../../assets/img/images.jpeg';

  driver: any;
  //'id',
  //'email',
  //'lastname',
  //    'date',
  displayedColumns: string[] = [
    'firstname',
    'status',
    //'plate',
    'imageUrl',
    'actions',
  ];

  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  productLat: any;
  productLong: any;
  marker: any;
  map: any;
  markers: any = [];
  companyId: any;
  listCars: any = [];

  trackRoute: any = [];

  pathLine: any;

  mapOptions: any;

  constructor(private afs: FirestoreService) {}

  ngOnInit() {


    this.user = this.afs.usersShow;

    this.companyId = this.user.companyId;

    this.afs.getAllVehicle(this.companyId).subscribe((cars) => {
      this.listCars = cars;
    });

    this.afs.getAllDriversByCompany(this.companyId).subscribe((users) => {
      this.dataSource.data = users;
    });

    this.getTomorrow();

  }

  getTomorrow() {
    let d = new Date();
    d.setDate(d.getDate());
    this.dateto = d;
    this.dateend = d;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.mapInitializer();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sortData(sort: Sort) {
    //const data = ELEMENT_DATA.slice();
    if (!sort.active || sort.direction === '') {
      //this.sortedData = data;
      return;
    }
  }

  newUser() {
    console.log('New User');
  }

  editUser(user) {
    console.log(user);
    this.user = user;
  }

  deleteUser(user) {

      Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {

        this.afs.deleteUser(user.id)
          .then((resp: any) => {
                 Swal.fire('Good job!', 'User has been deleted!!!!', 'success');
              })
          .catch((error) => {
                console.log(error);
          });
      }
    });


  }

  mapInitializer() {
    navigator.geolocation.getCurrentPosition((position) => {
      // place your product lat or longtitude here
      this.productLat = position.coords.latitude; // change it to your preferences
      this.productLong = position.coords.longitude; // <-- static
      const coordinates = new google.maps.LatLng(
        this.productLat,
        this.productLong
      ); // init our coordinate for marker :)

      /*this.marker = new google.maps.Marker({
      position: coordinates,
      map: this.map
    })*/
      // check here to get to know about map options docs
      this.mapOptions = {
        // here to place centering our location based on coordinates
        center: coordinates,
        zoom: 17,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
      };

      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    });
  }

  setMapOnAll(map) {
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
  }

  clearMarkers() {
    this.setMapOnAll(null);
  }

  deleteMarkers() {
    this.clearMarkers();
    this.markers = [];
  }

  addMarkersCustomer(customers: any) {
    customers.forEach((cus) => {
      const coordinates = new google.maps.LatLng(cus.latitude, cus.longitude);

      this.map.setZoom(18);
      this.map.setCenter(coordinates);

      this.marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: coordinates,
      });

      this.markers.push(this.marker);
    });
  }

  /**
   * Draw routes with polylines
   */
  drawRoute(tracks: any) {
    if (tracks.length > 1) {
      this.deleteMarkers();

      this.map.setZoom(16);

      this.map.setCenter(
        new google.maps.LatLng(
          tracks[tracks.length - 1].lat,
          tracks[tracks.length - 1].lng
        )
      );

      this.pathLine = new google.maps.Polyline({
        map: this.map,
        path: tracks,
        geodesic: true,
        strokeColor: '#192a56',
        strokeOpacity: 1.0,
        strokeWeight: 4,
      });

      this.pathLine.setMap(this.map);

      const coordinates = new google.maps.LatLng(
        tracks[tracks.length - 1].lat,
        tracks[tracks.length - 1].lng
      );

      this.marker = new google.maps.Marker({
        map: this.map,
        position: coordinates,
      });

      this.markers.push(this.marker);
    } else {
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

      /*   tracks = [{ lat: 0, lng: 0}]

          this.pathLine = new google.maps.Polyline({
            map: this.map,
            path: tracks,
            geodesic: true,
            strokeColor: '#e67e22',
            strokeOpacity: 1.0,
            strokeWeight: 4
        });
           this.pathLine.setMap(this.map);*/
    }
  }

  seeRoute(user) {


    let dateStart = this.dateto;
    let dateEnd = this.dateto;

    this.afs.getUser(user.id).subscribe((res) => {
      this.driver = res;
    });


    Swal.fire({
      title: 'Loading Data!',
      //html: 'data uploading', // add html attribute if you want or remove
      timer: 5000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    let ordersPush = [];

    // this.pathLine = null;
    //this.pathLine.setMap(null);

    let deliverydate = new Date().setHours(0, 0, 0, 0);


    dateStart = new Date(this.dateto).setHours(0, 0, 0, 0);
    dateEnd = new Date(this.dateto).setHours(23, 59, 59, 59);


    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

    this.afs
      .getTrackingById(user.id, this.user.companyId, dateStart, dateEnd)
      .subscribe((res) => {
        this.trackRoute = [];

        if (res.length == 0) {
          this.drawRoute(this.trackRoute);
        } else {
          res.forEach((docs) => {
            this.trackRoute.push({ lat: docs.latitude, lng: docs.longitude });

            if (res.length == this.trackRoute.length) {
              this.drawRoute(this.trackRoute);
            }
          });
        }
      });

    this.deleteMarkers();

    this.afs
      .getOrdersByDriver(this.user.companyId, user.id, deliverydate)
      .then((order) => {
        order.forEach((docs) => {
          //ordersPush.push(docs.data());
        });

        this.addMarkersCustomer(ordersPush);
      });
  }

  getPlate(element) {
    let carsUs = this.listCars.filter((car) => element.id == car.driverId);

    if (carsUs.length > 0) {
      return carsUs[0].plate;
    } else {
      return 'No Car';
    }
  }

  stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf('mm');
    var dayIndex = formatItems.indexOf('dd');
    var yearIndex = formatItems.indexOf('yyyy');
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(
      dateItems[yearIndex],
      month,
      dateItems[dayIndex]
    );
    return formatedDate;
  }

  searchByDate() {
    let dateto = new Date(this.forma.value.dateto).getTime();

    console.log(dateto);

    /*this.afs
      .getAllOrdersByDate(this.user.companyId, dateto, datefrom)
      .subscribe((orders) => {
        this.dataSource.data = orders;
      });*/
  }
}
